module.exports = __webpack_public_path__ + "img/doc_transform.22495a9e.svg";